import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.hasDashboardAccess().pipe(
      take(1),
      map(hasAccess => {
        if (hasAccess) {
          return true;
        } else {
          // Redirigir al chat si no tiene acceso de administrador
          this.router.navigate(['/chat']);
          return false;
        }
      })
    );
  }
}
